const PIXEL_ID = '1988817348410813'
let initialized = false

function getFbq(): ((...args: any[]) => void) | null {
  return (window as any).fbq || null
}

export function initMetaPixel() {
  if (initialized) return
  initialized = true

  const w = window as any
  if (!w.fbq) {
    const n = (w.fbq = function () {
      n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments)
    })
    n.push = n
    n.loaded = true
    n.version = '2.0'
    n.queue = []
    w._fbq = n
  }

  // Load the FB pixel script
  const s = document.createElement('script')
  s.async = true
  s.src = 'https://connect.facebook.net/en_US/fbevents.js'
  document.head.appendChild(s)

  // Queue init + pageview (the queue handles calls before script loads)
  w.fbq('init', PIXEL_ID)
  w.fbq('track', 'PageView')
}

export function trackAddToCart() {
  const fbq = getFbq()
  if (fbq) {
    fbq('track', 'AddToCart', {
      content_name: 'Hígado Vital Bundle',
      content_type: 'product',
      value: 6.39,
      currency: 'USD',
    })
  }
}
